import React, { FunctionComponent, Fragment, useContext } from 'react';
import { FormContext } from '../../../store/refinance/RefinanceContext';
import { useStepper } from '../../../utils';
import { numberToCurrency } from '../../../utils/formatting';
import { Button } from '../../shared/Button';
import { Text } from '../../shared/Text';
import { ArrowLongDown } from '../../../icons/components';
import { RefinanceResponse } from '../../../models/RefinanceReponse';
import { getFormattedDuration } from '../../../utils/dates';

export const RefinanceResult: FunctionComponent<{ data: RefinanceResponse }> = ({data}) => {
	const {setCurrentStep, setStepActive} = useStepper();

	const formContext = useContext(FormContext);

	const setFirstStepActive = () => {
		formContext.updateData(null)
		setCurrentStep(3);
		setStepActive(3, true);
	};

	const explanation =
		<Fragment>De bruto maandlasten waren {numberToCurrency(data.monthlyPayment.old, true)} en worden na oversluiten <strong>{numberToCurrency(data.monthlyPayment.new, true)}</strong>. De totale kosten voor het oversluiten zijn {numberToCurrency(data.cost.total, true)}, bestaande uit {numberToCurrency(data.cost.penaltyInterest, true)} vergoeding voor het vervroegd aflossen en {numberToCurrency(data.cost.transfer, true)} oversluitkosten.</Fragment>

	const result =
		<Fragment>De maandlasten <span className={(data.monthlyPayment.benefit <= 0) ? "u-text--error" : "u-text--success"}>{(data.monthlyPayment.benefit <= 0) ? 'stijgen' : 'dalen'}</span> met</Fragment>
	return (
		<Fragment>
			{data &&
			<div className="c-refinance-result">
				<button className="stepper__back-button" onClick={setFirstStepActive}>
                    <span className="stepper__back-button-icon">
                        <ArrowLongDown width={12}/>
                    </span>
					Vorige stap
				</button>
				<div className="stepper__step stepper__step--is-active stepper__step--is-touched">
					<div className="stepper__step-content">
						<div className="c-refinance-result__wrapper">
							<Text as="h3">{result}</Text>
							<Text as="h2">{numberToCurrency(Math.abs(data.monthlyPayment.benefit), true)}</Text>
							<p>{explanation}</p>
							<span className="stepper__step-title">{(data.cost.paidOffPeriod === -1) ? `Terugverdienen van de totale kosten is` : `De totale kosten worden terugverdiend in`}</span>
							<Text as="h3" className={(data.cost.paidOffPeriod === -1) ?  'u-text--error' : 'u-text--success'}>{(data.cost.paidOffPeriod === -1) ? `niet haalbaar` : getFormattedDuration(data.cost.paidOffPeriod)}</Text>
							<p>Het is belangrijk om een geschikte rentevaste periode te kiezen, die passend is bij de oversluitkosten en jouw persoonlijke situatie. De kosten die je maakt voor het oversluiten moeten minimaal kunnen worden terugverdiend in de nieuwe rentevaste periode. Wij raden daarom altijd aan om je te laten adviseren door een hypotheekadviseur.</p>
							<span className={'hidden'} id={'bc_months'}>{data.cost.paidOffPeriod}</span>
						</div>
					</div>
				</div>

				<div className="c-refinance-result__cta">
					<Text as="p">
            Wil je een deskundig en persoonlijk advies bij het oversluiten van je hypotheek?
            Maak een afspraak op een vestiging van De Hypotheker bij jou in de buurt.
            De eerste afspraak is voor onze rekening. Je kunt van deze berekening gebruik maken als je een annuïteiten-, lineaire of aflossingsvrije hypotheek (of hypotheekdeel) hebt. Heb je een ander type hypotheek, maak dan een <a href={"https://www.hypotheker.nl/afspraak-maken-hypotheekadviseur/"}>vrijblijvende afspraak</a> om te kijken of oversluiten ook voor jou voordelig is.
					</Text>
					<Button variant="tertiary" label="Afspraak maken"
									url={`/afspraak`}></Button>
				</div>
			</div>
			}
		</Fragment>
	);
};
